export var MIGRATION_ASSIST_TABLE_SCHEMA = {
    name: 'alloy_db_schema_table',
    indices: [],
    key: {
        path: 'name',
    },
    properties: [],
};
//# sourceMappingURL=migration.js.map